<!-- Inject all fonts -->
@if (sanitizedSupportedCssFonts && sanitizedSupportedCssFonts.length > 0) {
  @for (sanitizedFont of sanitizedSupportedCssFonts; track sanitizedFont) {
    <link [href]="sanitizedFont" rel="stylesheet" />
  }
}
<div class="brand-settings-customization" [ngClass]="{ 'page-templates': isBrandVarPageForTemplatePage }">
  @if (!loadingCustomFonts && !loadingAccountVariables) {
    <h2 class="brand-title">
      {{ (!isBrandVarPageForTemplatePage ? "settings.customization.brand-title" : "settings.customization.select-initial-bv") | translate }}
    </h2>
  }

  @if (!loadingCustomFonts && !loadingAccountVariables) {
    <div class="settings-container">
      @if (!loadingBrandVariables) {
        <mat-tab-group [(selectedIndex)]="selectedTab">
          <!-- START COLOR-FONT SECTION -->
          @if (!isBrandVarPageForTemplatePage) {
            <mat-tab [label]="TabsBrandSettings.BrandDesign">
              <ng-template mat-tab-label>
                <label (click)="saveBrandSettingsByClickOnTab(TabsBrandSettings.BrandDesign)">
                  {{ "settings.customization.brandDesign" | translate }}
                </label>
              </ng-template>
              <!-- START COLOR SECTION -->
              <section class="color-section">
                <!-- existed colors -->
                <h4 class="header-br">{{ "settings.customization." + TabsBrandSettings.ColorPalette | translate }}</h4>
                <p class="description" [innerHTML]="'settings.customization.colors.description' | translate"></p>
                <div class="color-wrapper">
                  @for (color of accountColors; track color) {
                    <div class="color-item">
                      <div class="color-key-field">
                        <mat-form-field [disabled]="savingInProgress">
                          <input
                            #inputRef
                            matInput
                            type="text"
                            [(ngModel)]="color.key"
                            (input)="inputColorKey(color)"
                            (blur)="editAccountColorOnBlur(color, $event)"
                            (keydown.enter)="editAccountColorOnEnter(color, $event)"
                            placeholder="{{ 'settings.customization.colors.color' | translate }}" />
                        </mat-form-field>
                        @if (color.errorKeyColor) {
                          <mat-hint class="error">* {{ color.errorKeyColor }}</mat-hint>
                        }
                      </div>
                      <p class="color-picker-button rectangular" [style.backgroundColor]="color?.value" [matMenuTriggerFor]="colorPicker"></p>
                      <mat-menu #colorPicker="matMenu" class="colors-menu-modal" (closed)="onMenuColorClosed(color)">
                        <div mat-menu-item class="wrapper-color-picker" [disableRipple]="true">
                          <app-color-picker
                            (click)="closeColorMenu($event)"
                            [inputAccountColors]="[]"
                            [currentColor]="color.value"
                            (customColorUpdated)="changeOnColorPicker($event, color)"
                            (enterInput)="closeColorMenu()"
                            [firstTab]="countOpenMenu"></app-color-picker>
                        </div>
                      </mat-menu>
                      <div class="value-color-field variable-field">
                        <mat-form-field appearance="outline" [disabled]="savingInProgress">
                          <input
                            matInput
                            type="text"
                            [(ngModel)]="color.value"
                            (input)="inputColorValue(color)"
                            (blur)="editAccountColorOnBlur(color, $event)"
                            (keydown.enter)="editAccountColorOnBlur(color)"
                            placeholder="{{ 'settings.customization.colors.color' | translate }}" />
                        </mat-form-field>
                        @if (color.errorValueColor) {
                          <mat-hint class="error">* {{ color.errorValueColor }}</mat-hint>
                        }
                      </div>
                      <mat-icon class="delete-icon" (click)="deleteAccountVariable(color, AccountVariableTypes.Color)">highlight_off</mat-icon>
                    </div>
                  }
                </div>
                <div class="color-wrapper">
                  @if (accountColors.length < 25) {
                    <button class="secondary-button transparent-button" [disabled]="newColor && (newColor.key || newColor.value)" (click)="addNewColorFields()">
                      <span class="btn-label">
                        <mat-icon>add_circle_outline</mat-icon>
                        <span class="text-add">{{ "generic.add" | translate }}</span>
                      </span>
                    </button>
                  }
                </div>
              </section>
              <!-- START FONT SECTION -->
              <section class="font-section">
                <h4 class="header-br">{{ "settings.customization." + TabsBrandSettings.Fonts + ".title" | translate }}</h4>
                <p class="description" [innerHTML]="'settings.customization.fonts.description' | translate"></p>
                <div class="font-wrapper">
                  @for (font of customFonts; track font) {
                    <div class="font-item">
                      <div
                        class="text-name variable-field"
                        (click)="addEditCustomFont(font)"
                        [matTooltip]="'settings.customization.fonts.edit-font' | translate">
                        <span [style.font-family]="font.name">{{ font.displayName }}</span>
                        <span class="font-type">
                          @if (font.type === AccountCustomFontTypes.CssLink) {
                            <span>&nbsp;({{ "settings.customization.fonts.css-link" | translate }})</span>
                          }
                          @if (font.type === AccountCustomFontTypes.UploadedFont) {
                            <span>&nbsp;({{ "settings.customization.fonts.uploaded" | translate }})</span>
                          }
                        </span>
                      </div>
                      <mat-icon class="delete-icon" (click)="deleteFont(font)">highlight_off</mat-icon>
                    </div>
                  }
                  <button class="secondary-button transparent-button" (click)="addEditCustomFont()">
                    <span class="btn-label">
                      <mat-icon>add_circle_outline</mat-icon>
                      <span class="text-add">{{ "generic.add" | translate }}</span>
                    </span>
                  </button>
                </div>
              </section>
            </mat-tab>
          }
          <!-- END COLOR-FONT SECTION -->
          @if (brandVariables) {
            <mat-tab [label]="TabsBrandSettings.CampaignDesign">
              <ng-template mat-tab-label>
                <label (click)="saveBrandSettingsByClickOnTab(TabsBrandSettings.CampaignDesign)">
                  {{ "settings.customization." + TabsBrandSettings.CampaignDesign | translate }}
                </label>
              </ng-template>
              <section class="brand-variables-section">
                <div class="brand-variables-container">
                  <app-brand-variables
                    [setBrandVariables]="{ brandVariables, initialBrandVariables, type: TabsBrandSettings.CampaignDesign }"
                    [defaultFonts]="defaultFonts"
                    [customFonts]="customFonts"
                    [accountColors]="accountColors"
                    [isAutomaticallyGenerated]="isAutomaticallyGenerated"
                    [isBrandVarPageForTemplatePage]="isBrandVarPageForTemplatePage"
                    (addEditCustomFont)="addEditCustomFont()"
                    (saveBrandVariables)="saveBrandVariables()"
                    (onChangeBrandVariables)="onChangeBrandVariables.emit($event)"
                    (brandVarCanBeSavedOnClickTab)="brandVarCanBeSavedOnClickTab = $event"
                    (onPreviewRefresh)="onPreviewRefresh($event)"></app-brand-variables>
                </div>
              </section>
              <div class="brand-preview-wrapper">
                <app-brand-settings-preview [brandVariablesPreview]="{ brandVariablesPreview, selectedTab }"></app-brand-settings-preview>
              </div>
            </mat-tab>
          }
          @if (brandVariables) {
            <mat-tab [label]="TabsBrandSettings.FormDesign">
              <ng-template mat-tab-label>
                <label (click)="saveBrandSettingsByClickOnTab(TabsBrandSettings.FormDesign)">
                  {{ "settings.customization." + TabsBrandSettings.FormDesign | translate }}
                </label>
              </ng-template>
              <section class="brand-variables-section">
                <div class="brand-variables-container">
                  <app-brand-variables
                    [setBrandVariables]="{ brandVariables, initialBrandVariables, type: TabsBrandSettings.FormDesign }"
                    [defaultFonts]="defaultFonts"
                    [customFonts]="customFonts"
                    [accountColors]="accountColors"
                    [isAutomaticallyGenerated]="isAutomaticallyGenerated"
                    [isBrandVarPageForTemplatePage]="isBrandVarPageForTemplatePage"
                    (addEditCustomFont)="addEditCustomFont()"
                    (saveBrandVariables)="saveBrandVariables()"
                    (onChangeBrandVariables)="onChangeBrandVariables.emit($event)"
                    (brandVarCanBeSavedOnClickTab)="brandVarCanBeSavedOnClickTab = $event"
                    (onPreviewRefresh)="onPreviewRefresh($event)"></app-brand-variables>
                </div>
              </section>
              <div class="brand-preview-wrapper">
                <app-brand-settings-preview
                  [isBrandVarPageForTemplatePage]="isBrandVarPageForTemplatePage"
                  [brandVariablesPreview]="{ brandVariablesPreview, selectedTab }"></app-brand-settings-preview>
              </div>
            </mat-tab>
          }
          <!-- END BRAND VARIABLE SECTION -->
          <!-- START TEXT SECTION -->
          @if (!isBrandVarPageForTemplatePage) {
            <mat-tab [label]="TabsBrandSettings.TextVariables">
              <ng-template mat-tab-label>
                <label (click)="saveBrandSettingsByClickOnTab(TabsBrandSettings.TextVariables)">
                  {{ "settings.customization." + TabsBrandSettings.TextVariables | translate }}
                </label>
              </ng-template>
              <section class="text-section">
                <!-- existed texts -->
                <h4 class="header-br">{{ "settings.customization." + TabsBrandSettings.TextVariables | translate }}</h4>
                <p class="description" [innerHTML]="'settings.customization.text-variables.description' | translate"></p>
                <div class="text-wrapper">
                  @for (text of accountTextVariables; track text) {
                    <div class="text-item">
                      <div class="text-name variable-field">
                        <p>{{ text.key }}</p>
                      </div>
                      <div class="value-text-field variable-field area">
                        <mat-form-field appearance="outline" [disabled]="savingTextInProgress">
                          <textarea
                            matInput
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"
                            type="text"
                            [(ngModel)]="text.value"
                            (input)="inputTextValue(text)"
                            placeholder="{{ 'settings.customization.text-variables.key' | translate }}"></textarea>
                        </mat-form-field>
                        @if (text.errorValueText) {
                          <mat-hint class="error">* {{ text.errorValueText }}</mat-hint>
                        }
                      </div>
                      <mat-icon
                        class="edit-icon"
                        [matTooltip]="text.errorValueText ? text.errorValueText : text.saveDisabled ? ('generic.validation.nothing-to-save' | translate) : null"
                        [ngClass]="{ disabled: text.errorValueText || text.saveDisabled }"
                        (click)="editAccountText(text)">
                        save
                      </mat-icon>
                      <mat-icon class="delete-icon" (click)="deleteAccountVariable(text, AccountVariableTypes.Text)">highlight_off</mat-icon>
                    </div>
                  }
                </div>
                <!-- new text -->
                <div class="text-wrapper">
                  @if (newText) {
                    <div class="text-item">
                      @if (newText?.key || newText?.key === "") {
                        <div class="new-text-field variable-field">
                          <mat-form-field appearance="outline" [disabled]="savingTextInProgress">
                            <input
                              matInput
                              type="text"
                              [(ngModel)]="newText.key"
                              (input)="validateTextKey(newText)"
                              placeholder="{{ 'settings.customization.text-variables.key' | translate }}" />
                          </mat-form-field>
                          @if (errorKeyText) {
                            <mat-hint class="error">* {{ errorKeyText }}</mat-hint>
                          }
                        </div>
                      }
                      @if (newText?.value || newText?.value === "") {
                        <div class="new-text-field variable-field area">
                          <mat-form-field appearance="outline" [disabled]="savingTextInProgress">
                            <textarea
                              matInput
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="5"
                              type="text"
                              [(ngModel)]="newText.value"
                              (input)="validateTextValue(newText)"
                              placeholder="{{ 'settings.customization.text-variables.value' | translate }}"></textarea>
                          </mat-form-field>
                          @if (errorValueText) {
                            <mat-hint class="error">* {{ errorValueText }}</mat-hint>
                          }
                        </div>
                      }
                      <mat-icon
                        class="edit-icon"
                        [matTooltip]="
                          errorValueText
                            ? errorValueText
                            : errorKeyText
                              ? errorKeyText
                              : newText.key === '' || newText.value === ''
                                ? ('generic.validation.nothing-to-save' | translate)
                                : null
                        "
                        [ngClass]="{
                          disabled: errorValueText || errorKeyText || newText.value === '' || newText.key === '' || accountTextVariables?.length >= 40,
                        }"
                        (click)="createdAccountText()">
                        save
                      </mat-icon>
                      <mat-icon class="delete-icon" (click)="deleteNewTextFields()">highlight_off</mat-icon>
                    </div>
                  }
                  <button class="secondary-button transparent-button" [disabled]="newText || accountTextVariables?.length >= 40" (click)="addNewTextFields()">
                    <span class="btn-label">
                      <mat-icon>add_circle_outline</mat-icon>
                      <span class="text-add">{{ "generic.add" | translate }}</span>
                    </span>
                  </button>
                </div>
              </section>
            </mat-tab>
          }
          <!-- END TEXT SECTION -->
        </mat-tab-group>
      }
    </div>
  } @else {
    <div class="settings-container loading-container">
      <app-indeterminate-progress-dialog></app-indeterminate-progress-dialog>
    </div>
  }
  <div class="actions-row dialog-row bv-actions-row">
    @if (isBrandVarPageForTemplatePage) {
      <button [disabled]="loadingCustomFonts || loadingAccountVariables" class="underline-button" type="button" (click)="skipBrandSettings()">
        {{ "generic.do-it-later" | translate }}
      </button>
    }
    @if (!isBrandVarPageForTemplatePage) {
      <div
        class="copy-bv-button-wrapper"
        [matTooltip]="customer?.siteIds?.length === 1 && !user?.isAdmin ? ('settings.customization.brand-settings.warning-copy-bv' | translate) : ''">
        <button
          [disabled]="customer?.siteIds?.length === 1 && !user?.isAdmin"
          class="secondary-button copy-bv-button"
          mat-stroked-button
          (click)="openCopyBrandSettings()">
          <span class="btn-label">{{ "settings.customization.brand-settings.copy-bv" | translate | uppercase }}</span>
        </button>
      </div>
    }
    @if (selectedTab !== tabGroup?._tabs?.length - 1) {
      <button (click)="nextTab()" [disabled]="loadingCustomFonts || loadingAccountVariables" mat-stroked-button class="primary-button next-btn">
        <span class="btn-label">
          @if (!isBrandVarPageForTemplatePage) {
            {{ "generic.save" | translate | uppercase }} &
          }
          {{ "generic.next" | translate | uppercase }}
          <mat-icon>arrow_right</mat-icon>
        </span>
      </button>
    }
    @if (isBrandVarPageForTemplatePage) {
      <div class="save-btn-wrapper" [style.margin.px]="selectedTab !== tabGroup?._tabs?.length - 1 ? 0 : 15">
        @if (selectedTab === tabGroup?._tabs?.length - 1) {
          <button mat-stroked-button class="primary-button" (click)="saveAllBrandSettings()">
            <span class="btn-label">{{ "generic.save" | translate | uppercase }}</span>
          </button>
        }
      </div>
    }
  </div>
</div>
